<div
  *ngIf="ready && !visibility.isHidden"
  [style.visibility]="visibility.isInvisible ? 'hidden' : 'visible'"
>
  <div class="linkContent indent">
    <a
      *ngIf="link.url; else linkTemplate"
      [href]="link.url"
      target="_blank"
      rel="noopener noreferrer"
      (click)="onClick()"
      >{{ linkText }}</a
    >
    <ng-template #linkTemplate>
      <button type="button" (click)="onClick()">{{ linkText }}</button>
    </ng-template>
  </div>
</div>
